import Logo from "../assets/images/logo.svg"
import GoogleAD from "../assets/images/GoogleAD.png"
import LeftBanner from "../assets/images/leftBanner.png"
import GooglePlay from "../assets/images/GooglePlay.png"
import AppStore from "../assets/images/AppStore.png"
import RightBanner from "../assets/images/rightTop.png"
import BottomBanner from "../assets/images/bottomBanner.png"
import RedLionsLogo from "../assets/images/redLionsLogo.png"
import PhoenixLogo from "../assets/images/phoenixLogo.png"
import VectorUp from "../assets/images/VectorUp.svg"
import VectorDown from "../assets/images/VectorDown.svg"
import Vector2 from "../assets/images/Vector2.svg"
import Kunal from "../assets/images/kunal.png"
import Trophy from "../assets/images/TrophyStar.png"
import Page from "../assets/images/page_404.svg"
import Winning from "../assets/gif/winning.gif"
import BackArrow from "../assets/images/arrow_back.svg"
import LiveMatch from "../assets/images/liveMatch.svg"
import Refresh from "../assets/images/Refresh.svg"
import NoData from "../assets/images/noData.svg"
import DefaultLoader from "../assets/images/defaultLoaderImg.svg"
import YetBat from "../assets/images/yetBat.svg"
import NoYetData from "../assets/images/noYetData.svg"
import Bgreen from "../assets/images/bgGreen.png"
import Bbrown from "../assets/images/bgBrown.png"
import OngoingIcon from "../assets/images/ongoing.svg"

const IMAGES = {
	LOGO: Logo,
	GOOGLE_AD: GoogleAD,
	LEFT_BANNER: LeftBanner,
	GOOGLE_PLAY: GooglePlay,
	APP_STORE: AppStore,
	RIGHT_BANNER: RightBanner,
	BOTTOM_BANNER: BottomBanner,
	RED_LIONS_LOGO: RedLionsLogo,
	PHOENIX_LOGO: PhoenixLogo,
	VECTOR_UP: VectorUp,
	VECTOR_DOWN: VectorDown,
	VECTOR2: Vector2,
	KUNAL: Kunal,
	TROPHY: Trophy,
	PAGE: Page,
	WINNING: Winning,
	BACKARROW: BackArrow,
	LIVEMATCH: LiveMatch,
	REFRESH: Refresh,
	NODATA: NoData,
	DEFAULTLOADER: DefaultLoader,
	YETBAT: YetBat,
	NOYETDATA: NoYetData,
	BGGREEN : Bgreen,
	BGBROWN : Bbrown,
	ONGOINGICON : OngoingIcon
}

export default IMAGES